module.exports = __webpack_public_path__ + "img/inn-red.3fe73e5b.svg";